import React, { ComponentProps } from "react";

import List from "components/List/List";

import classNames from "classnames";
import { map } from "lodash-es";

import { Suggestion, Lookup } from "./AddressInput";
import SuggestionsItem from "./AddressInputSuggestionItem";

interface SuggestionsProps {
  isOpen: boolean;
  highlightedIndex: number;
  getItemProps: ComponentProps<typeof SuggestionsItem>["getItemProps"];
  getMenuProps: () => Record<string, any>;
  suggestions: Lookup | undefined;
  selectSuggestion?: (suggestion: Suggestion) => void;
}

const Suggestions: React.FC<SuggestionsProps> = ({
  isOpen,
  getItemProps,
  getMenuProps,
  highlightedIndex,
  suggestions,
}) => {
  const search = suggestions?.search || "";
  const { ref, ...menuProps } = getMenuProps();

  const suggestionItems = suggestions?.result || [];
  const emptySuggestions = suggestionItems.length === 0;
  const classes = classNames("address-verifications-suggestions__wrapper", {
    "appear-hidden": emptySuggestions || !isOpen,
  });

  return (
    <div
      className={classNames("address_input__suggestions_container", {
        address_input__suggestions_container__opened: isOpen,
      })}>
      <div ref={ref} className={classes}>
        <List
          data-testid="address-suggestions__list"
          className={classNames("address-verifications-suggestions__list", { open: isOpen })}
          {...menuProps}>
          {isOpen &&
            map(suggestionItems, (item: Suggestion, index: number) => (
              <SuggestionsItem
                key={index}
                item={item}
                index={index}
                search={search}
                highlighted={highlightedIndex === index}
                getItemProps={getItemProps}
              />
            ))}
        </List>
      </div>
    </div>
  );
};

export default Suggestions;
